import { render, staticRenderFns } from "./renderStastic.vue?vue&type=template&id=e4af5a7a&scoped=true&"
import script from "./renderStastic.vue?vue&type=script&lang=js&"
export * from "./renderStastic.vue?vue&type=script&lang=js&"
import style0 from "./renderStastic.vue?vue&type=style&index=0&id=e4af5a7a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4af5a7a",
  null
  
)

export default component.exports